import { type Route } from '@angular/router';
import { frameLayoutConfig } from '@bizzdesign/feature-layout';
import { canAccess } from '@bizzdesign/shared/utils';
import { frameRouteRunGuardsAndResolvers } from '@bizzdesign/workspaces/utils';
import type { FrameContainerComponent } from '../containers/frame-container/frame-container.component';
import { frameContextResolver } from '../resolvers/frame-context-resolver';
import {
  adhocFrameMatcher,
  frameMatcher,
  viewsMatcher,
} from '../utils/matcher.utils';

const defaultFrameRouteData: Route = {
  loadComponent: () =>
    import('../containers/frame-container/frame-container.component').then(
      (m) => m.FrameContainerComponent,
    ),
  data: { layoutConfig: frameLayoutConfig },
  resolve: {
    context: frameContextResolver,
  },
  runGuardsAndResolvers: frameRouteRunGuardsAndResolvers,
  canDeactivate: [(c: FrameContainerComponent) => c.canDeactivate()],
};

export const FEATURE_FRAME_ROUTES: Route[] = [
  {
    ...defaultFrameRouteData,
    matcher: frameMatcher,
    canActivate: [canAccess('workspaces', 'manage')],
  },
];

export const FEATURE_FRAME_VIEW_ROUTES: Route[] = [
  {
    ...defaultFrameRouteData,
    matcher: viewsMatcher,
    canActivate: [],
  },
];

export const FEATURE_FRAME_OUTLET_ROUTES: Route[] = [
  {
    outlet: 'overlay',
    matcher: adhocFrameMatcher,
    loadComponent: () =>
      import('../containers/frame-container/frame-container.component').then(
        (m) => m.FrameContainerComponent,
      ),
    data: { layoutConfig: null },
    resolve: { context: frameContextResolver },
    runGuardsAndResolvers: frameRouteRunGuardsAndResolvers,
  },
];
